/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import TToggle, { ToggleAnalytics } from './Toggle';
import './styles.scss';
import { ToolkitTrackerProps } from '../../analytics';
import { ToggleProps } from '@veneer/core';

/**
 * UI Toolkit Toggle component
 * @public
 */
const Toggle: React.FC<ToggleProps & ToolkitTrackerProps> = ({
  trackId,
  trackCategory,
  trackedHandlers,
  untrackedHandlers,
  stopTracking,
  canReturnParams,
  ...rest
}) => {
  if (trackId) {
    return (
      <ToggleAnalytics
        trackId={trackId}
        trackCategory={trackCategory}
        trackedHandlers={trackedHandlers}
        untrackedHandlers={untrackedHandlers}
        stopTracking={stopTracking}
        canReturnParams={canReturnParams}
        {...rest}
      />
    );
  }
  return <TToggle {...rest} />;
};

export default Toggle;
